import PropTypes from 'prop-types';
import { UserExact } from './User';
import { PilotExact } from './Pilot';
import { DictionaryExact } from './Dictionary';

const Client = {
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  users: PropTypes.arrayOf(UserExact),
  irthConfig: PropTypes.object,
  pilots: PropTypes.arrayOf(PilotExact),
  dictionaries: PropTypes.arrayOf(DictionaryExact),
};

export const ClientShape = PropTypes.shape(Client);
export const ClientExact = PropTypes.exact(Client);
